<template>
  <app-nav>
    <router-view />
  </app-nav>
</template>

<script>
import AppNav from './components/AppNav/AppNav';

export default {
  components: {
    AppNav,
  },
};
</script>
